import type { Location, Patient, Reference } from '@medplum/fhirtypes'
import {
  ExtendedEncounter,
  type ExtendedEncounterArgs,
} from '#src/models/encounters/encounter.ts'
import type { QueryTypes } from '#src/search.ts'

export class LocationBasedEncounter extends ExtendedEncounter {
  constructor(
    args: Omit<ExtendedEncounterArgs, 'location'> & {
      location: Reference<Location>
    }
  ) {
    super({
      ...args,
      location: [{ location: args.location }],
    })
  }

  get location(): Reference<Location> | undefined {
    return this.resource.location?.[0]?.location
  }

  set location(location: Reference<Location>) {
    this.resource.location ??= []
    this.resource.location = [{ location }]
  }

  static searchByPatient(
    patient: Reference<Patient>,
    encounterClass: keyof typeof ExtendedEncounter.ENCOUNTER_CLASS
  ): QueryTypes {
    return {
      ...ExtendedEncounter.BASE_QUERY_STRUCTURE,
      class: encounterClass,
      subject: patient,
    }
  }

  static byPatientInProgress(
    patient: Reference<Patient>,
    encounterClass: keyof typeof ExtendedEncounter.ENCOUNTER_CLASS
  ): QueryTypes {
    return {
      ...ExtendedEncounter.BASE_QUERY_STRUCTURE,
      class: encounterClass,
      subject: patient,
      status: 'in-progress',
    }
  }
}
